// extracted by mini-css-extract-plugin
export default {"loaderContainer":"style_loaderContainer__kqaKu","loaderText":"style_loaderText__7meqV"};